import React from 'react';

import { cn } from '@pray/shared/utils/styles';

import type { BadgeProps } from './types';

/**
 * Badge component displays an icon on a styled background with gradient
 */
const Badge: React.FC<BadgeProps> = ({ icon, className = '' }) => {
  return (
    <div
      className={cn(
        'relative box-border flex size-10 flex-row items-center justify-center rounded-xl',
        'border border-[#E3AF4A1A] bg-[#171718] p-2 shadow-[3px_3px_18px_rgba(0,0,0,0.25)]',
        'before:pointer-events-none before:absolute before:inset-0 before:rounded-xl before:bg-radial-gradient-gold-0 before:content-[""] group-hover:before:bg-radial-gradient-gold-10',
        className
      )}
    >
      {React.cloneElement(icon, { className: 'absolute' })}
    </div>
  );
};

export default Badge;
